import { useEffect } from "react";

const SITE = "REVIVE Regenerative Medical Clinic";
const ORIGIN = "https://revivestem.com.mx";

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

// Per-route SEO without extra dependencies. Crawler-visible once the deployed
// app's bot-prerendering renders the React tree; static pages (contact/privacy/terms)
// already carry their own head tags.
const Seo = ({ title, description, path, robots, alternates }) => {
  useEffect(() => {
    if (title) document.title = title.includes("| REVIVE") || title.includes(SITE) ? title : `${title} | ${SITE}`;
    if (description) upsertMeta("name", "description", description);
    if (robots) upsertMeta("name", "robots", robots);
    const p = path || window.location.pathname;
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `${ORIGIN}${p}`);
    // hreflang alternates for bilingual page pairs
    document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((el) => el.remove());
    if (alternates) {
      Object.entries(alternates).forEach(([lang, href]) => {
        const el = document.createElement("link");
        el.setAttribute("rel", "alternate");
        el.setAttribute("hreflang", lang);
        el.setAttribute("href", href);
        document.head.appendChild(el);
      });
    }
  }, [title, description, path, robots, alternates]);
  return null;
};

export default Seo;
